import type { LoginTranslations } from '../interfaces/login';

export const loginTranslations: LoginTranslations = {
  title:
    'Convierte tus ideas en Agentes de IA conversacionales para todos tus canales',
  subtitle:
    'Empieza por la plataforma líder (WhatsApp) y escala fácilmente. La IA de {{brand}} se encarga de la automatización de las ventas y la atención.',
  morningMessages: [],
  afternoonMessages: [],
  eveningMessages: [],
  footerMessages: [
    'Creamos {{brand}} porque creemos que todos merecen construir algo grande sin límites. ¿Listo para empezar?',
    'No importa de dónde vengas, lo que importa es lo que creas. Con {{brand}}, el mundo es tu lienzo.',
    'Creamos {{brand}} para que tu idea cobre vida en segundos. Empieza hoy.',
    'Cada gran idea comienza con un primer paso. Hoy, ese paso es más fácil que nunca. ¡Construyamos el futuro juntos!',
    'Los límites no existen cuando tienes las herramientas adecuadas. Y ahora, tú las tienes.',
    'Un día soñamos con esto, y lo hicimos realidad. Hoy, te damos el poder para que tú también lo hagas.',
    'Comenzamos con una idea y una meta: demostrar que todo es posible. Ahora, es tu turno.',
    'Creíamos que podíamos hacerlo, y aquí estamos. No dudes de lo que puedes crear.',
    'No hay trucos, no hay secretos: solo creímos en nuestra idea y trabajamos por ella. Tú también puedes hacerlo.',
    'Si nosotros logramos construir esto desde cero, ¿qué te detiene a ti? Empieza hoy',
    'No esperes el momento perfecto. Nosotros no lo hicimos, solo empezamos. Ahora es tu turno.',
    'Creamos {{brand}} para demostrar que cualquier idea puede hacerse realidad. La tuya también.',
  ],
  google_button: 'Inicia sesión con Google',
  login_button: 'Iniciar sesión',
  input_user_label: 'Correo',
  input_user_placeholder: 'Correo',
  input_password_label: 'Contraseña',
  input_password_placeholder: 'Ingresa tu contraseña',
  checkbox_remember_me: 'Recuérdame',
  login_account_label_prefix: 'Ya tienes una cuenta?',
  login_account_label_button: 'Inicia sesión',
  terms_and_conditions: 'Términos y condiciones',
  google_forbidden_title: 'Acceso restringido',
  google_forbidden_description: 'Esta cuenta no puede iniciar sesión en este panel.',
};
